(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('barChart', barChartDirective)
    .controller('barChartController', barChartController);

  /** @ngInject */
  function barChartDirective ($timeout) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        chartId: '@'
      },
      templateUrl: 'app/components/barChart/barChart.html',
      controller: 'barChartController',
      controllerAs: 'vm',
      link: function (scope, element) {
        scope.vm.chartElementId += scope.chartId; // += scope.index;
        scope.vm.xAxisOptions = scope.options.x ? scope.options.x : {};
        angular.element(element.find('.barChartContainer')).attr('id', scope.vm.chartElementId);
        $timeout(function () {
          scope.vm.refresh(scope.options.data);
          scope.$watch('options.data', function (newValue) {
            scope.vm.refresh(newValue);
          });
        }, 100)
      }
    };
  }

  /** @ngInject */
  function barChartController ($scope, $translate) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'barChart';
    vm.refresh = refreshChart;
    vm.xAxisOptions = {};

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function refreshChart(data) {
      var groupColumnName = 'x',
        rowsData = [];

      if (!data) {
        return;
      }

      rowsData = [[groupColumnName].concat(data.facilities)];

      data.groups.forEach(function (item) {
        rowsData.push([item.group].concat(item.values));
      });

      vm.chart === null
        ? createChart(groupColumnName, rowsData, $translate.instant(data.unit))
        : updateChart(groupColumnName, rowsData, $translate.instant(data.unit));

    }

    function createChart(groupColumnName, rowsData, unit) {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: groupColumnName,
          rows: rowsData,
          type: 'bar'
        },
        bar: {
          width: {
            ratio: 0.5
          }
        },
        axis: {
          rotated: true,
          x: vm.xAxisOptions,
          y: {
            label: {
              text: '(' + unit + ')'
            }
          }
        }
      });
    }

    function updateChart(groupColumnName, rowsData, unit) {
      vm.chart.load({
        data: {
          x: groupColumnName,
          rows: rowsData,
          type: 'bar'
        },
        bar: {
          width: {
            ratio: 0.5
          }
        },
        axis: {
          rotated: true,
          x: vm.xAxisOptions,
          y: {
            label: {
              text: '(' + unit + ')'
            }
          }
        }
      });
    }
  }
})();
